<template>
  <table class="table">
    <tbody>
      <tr v-if="documentData.series">
        <td class="table-col">Серия</td>
        <td>{{ documentData.series }}</td>
      </tr>
      <tr>
        <td class="table-col">Номер</td>
        <td>{{ documentData.number }}</td>
      </tr>
      <tr>
        <td class="table-col">Дата выдачи</td>
        <td>{{ documentData.date | formatDate }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DocumentPassCarriageLicenceView',
  props: {
    documentData: {
      type: Object,
      default: null
    }
  },
}
</script>

<style scoped>
  .table-col {
    width: 50%;
  }
</style>
